import { useQuery } from '@tanstack/react-query';
import { endpoints } from '../constants/endpoints';
import axios from '../lib/axios';
import type { WhatsappTemplate } from '../types/whatsapp';

const TEMPLATES_QUERY_KEY = ['whatsapp-templates'];

export function useWhatsappTemplates() {
  return useQuery({
    queryKey: TEMPLATES_QUERY_KEY,
    queryFn: async () => {
      const templates: WhatsappTemplate[] = await axios.get(
        endpoints.whatsapp.templates,
      );
      return templates;
    },
    retry: false,
  });
}
